import { SystemStyleObject } from '@styled-system/css';
import styled, { StyledComponent } from 'styled-components';
import {
  compose,
  shadow,
  ShadowProps,
  textStyle,
  TextStyleProps,
  typography,
  TypographyProps,
} from 'styled-system';
import Box, { BoxProps } from './Box';

export type BaseTextProps =
  | ShadowProps
  | TextStyleProps
  | TypographyProps
  | BoxProps;

interface OtherProps {
  textDecoration?: string;
  flexDirection?: SystemStyleObject;
  alignItems?: string;
  alignSelf?: string;
}

const Text: StyledComponent<'div', any, BaseTextProps & OtherProps, never> =
  styled(Box)(compose(shadow, textStyle, typography));
export default Text;
